import script from "./nnrc-survey.vue?vue&type=script&setup=true&lang=js"
export * from "./nnrc-survey.vue?vue&type=script&setup=true&lang=js"

import "./nnrc-survey.vue?vue&type=style&index=0&id=42a8a7ca&lang=scss"

const __exports__ = script;

export default __exports__